export const mocNavType = {
  componentContent: {
    typeRoute: [{
      'value': 0,
      'des': '首页',
      'route': '/indexpage/index',
      'title': '首页',
      'linkTo': '/indexpage/index'
    }, {
      'value': 1,
      'des': '全部检测',
      'route': '/indexpage/productlist',
      'title': '全部检测',
      'linkTo': '/indexpage/productlist'
    }]
  },
  index: 11,
  title: '专区导航',
  type: 'NavType'
};



// WEBPACK FOOTER //
// ./src/mocData/topTypeNav.js